import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'sonner'
import Home from './pages/Home'
import Auth from './pages/Auth'
import Dashboard from './pages/Dashboard'
import TeamSetup from './pages/TeamSetup'
import Portal from './pages/Portal'
import Unsubscribe from './pages/Unsubscribe'
import Settings from './pages/Settings'
import ParentManager from './pages/ParentManager'
import DispatchReview from './pages/DispatchReview'
import DispatchSend from './pages/DispatchSend'
import Pricing from './pages/Pricing'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import PaymentSuccess from './pages/PaymentSuccess'
import FileManager from './pages/FileManager'
import WikiManager from './pages/WikiManager'
import WikiReview from './pages/WikiReview'
import WikiEditor from './pages/WikiEditor'
import PortalBuilder from './pages/PortalBuilder'
import ResetPassword from './pages/ResetPassword'
import RosterManager from './pages/RosterManager'
import SnackScheduleManager from './pages/SnackScheduleManager'
import ScrimmageManager from './pages/ScrimmageManager'
import ScrimmageBulletin from './pages/ScrimmageBulletin'
import ScrimmageBulletinLanding from './pages/ScrimmageBulletinLanding'
import AILabHome from './pages/admin/AILabHome'
import AILabRun from './pages/admin/AILabRun'
import AILabResults from './pages/admin/AILabResults'
import SeedTeamsPage from './pages/admin/SeedTeamsPage'
import AIParserTestPage from './pages/admin/AIParserTestPage'
import SyncMonitor from './pages/admin/SyncMonitor'
import MatchValidation from './pages/admin/MatchValidation'
import ClaimTeam from './pages/ClaimTeam'
import ProtectedRoute from './components/auth/ProtectedRoute'
import { AI_LAB_ENABLED } from '@/lib/config'

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        richColors
        closeButton
        expand={true}
        gap={12}
      />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
        <Route path="/p/:slug" element={<Portal />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/scrimmages/bulletin" element={<ScrimmageBulletinLanding />} />
        <Route path="/scrimmages/bulletin/:sport" element={<ScrimmageBulletin />} />

        {/* Protected routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/team-setup" element={
          <ProtectedRoute>
            <TeamSetup />
          </ProtectedRoute>
        } />
        <Route path="/parents" element={
          <ProtectedRoute>
            <ParentManager />
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } />
        <Route path="/dispatch/review" element={
          <ProtectedRoute>
            <DispatchReview />
          </ProtectedRoute>
        } />
        <Route path="/dispatch/send" element={
          <ProtectedRoute>
            <DispatchSend />
          </ProtectedRoute>
        } />
        <Route path="/files" element={
          <ProtectedRoute>
            <FileManager />
          </ProtectedRoute>
        } />
        <Route path="/wiki" element={
          <ProtectedRoute>
            <WikiManager />
          </ProtectedRoute>
        } />
        <Route path="/wiki/review" element={
          <ProtectedRoute>
            <WikiReview />
          </ProtectedRoute>
        } />
        <Route path="/wiki/edit" element={
          <ProtectedRoute>
            <WikiEditor />
          </ProtectedRoute>
        } />
        <Route path="/portal/edit" element={
          <ProtectedRoute>
            <PortalBuilder />
          </ProtectedRoute>
        } />
        <Route path="/roster" element={
          <ProtectedRoute>
            <RosterManager />
          </ProtectedRoute>
        } />
        <Route path="/snacks" element={
          <ProtectedRoute>
            <SnackScheduleManager />
          </ProtectedRoute>
        } />
        <Route path="/scrimmages/manage" element={
          <ProtectedRoute>
            <ScrimmageManager />
          </ProtectedRoute>
        } />
        <Route path="/claim-team" element={
          <ProtectedRoute>
            <ClaimTeam />
          </ProtectedRoute>
        } />
        <Route path="/claim-team/:teamId" element={
          <ProtectedRoute>
            <ClaimTeam />
          </ProtectedRoute>
        } />
        <Route path="/admin/ai-lab" element={
          <ProtectedRoute adminOnly featureFlag={AI_LAB_ENABLED}>
            <AILabHome />
          </ProtectedRoute>
        } />
        <Route path="/admin/ai-lab/run" element={
          <ProtectedRoute adminOnly featureFlag={AI_LAB_ENABLED}>
            <AILabRun />
          </ProtectedRoute>
        } />
        <Route path="/admin/ai-lab/results" element={
          <ProtectedRoute adminOnly featureFlag={AI_LAB_ENABLED}>
            <AILabResults />
          </ProtectedRoute>
        } />
        <Route path="/admin/seed-teams" element={
          <ProtectedRoute adminOnly>
            <SeedTeamsPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/ai-parser-test" element={
          <ProtectedRoute adminOnly>
            <AIParserTestPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/sync-monitor" element={
          <ProtectedRoute adminOnly>
            <SyncMonitor />
          </ProtectedRoute>
        } />
        <Route path="/admin/match-validation" element={
          <ProtectedRoute adminOnly>
            <MatchValidation />
          </ProtectedRoute>
        } />
      </Routes>
    </>
  )
}

export default App
